/// <reference path="../../app.definition.ts" />

angular.module('eCareVault.common.factory')
        .factory('$_snackbar', ['$window',($window: ng.IWindowService) => $window.toastr || {}]);

